﻿export const EditorConstants = {
    FontSizes: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
    FontFamilies: ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'],
    HtmlHeaderValues: [false, 1, 2, 3, 4, 5]
}